import styled from 'styled-components';

const Alert = styled.span`
	font-size: 12px;
	font-weight: 300;
	color: red;
`;

export default Alert;
